<template>
  <div class="w100 childRoute-wrapper">
    <van-nav-bar
      :title="$t('personal.modifyAvatar')"
      :fixed="true"
      left-arrow
      @click-left="navBarBack"
    >
      <span slot="right" @click="cropper">
        {{ $t("common.save") }}
      </span>
    </van-nav-bar>
    <div class="scroll-wrapper">
      <vue-cropper
        ref="cropper"
        :autoCrop="true"
        :fixedBox="true"
        :canMoveBox="false"
        :img="example.img"
        :autoCropWidth="example.autoCropWidth"
        :autoCropHeight="example.autoCropHeight"
        :outputSize="example.size"
      ></vue-cropper>
    </div>
  </div>
</template>

<script>
import { VueCropper } from "vue-cropper";
export default {
  props: {
    img: {
      type: String,
      default: ""
    },
    showCropper: {
      type: Boolean,
      default: false
    }
  },
  components: {
    VueCropper
  },
  data() {
    return {
      example: {
        img: "",
        autoCropWidth: 300,
        autoCropHeight: 300,
        size: 0.5
      }
    };
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    navBarBack() {
      this.$emit("update:showCropper", false);
    },
    cropper() {
      this.$refs.cropper.getCropData(data => {
        this.$emit("cropper", data);
      });
    }
  },
  watch: {
    img: {
      handler() {
        this.example.img = this.img;
      },
      immediate: true
    }
  }
};
</script>

<style lang="less" scoped></style>
